import network from './network';

export default {
  network,
};
